import { useEffect, useState } from 'react'

/** «0:12», «3:05», «1:02:07»: прошедшее время целыми секундами. */
export function elapsedText(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(whole / 3600)
  const minutes = Math.floor((whole % 3600) / 60)
  const rest = String(whole % 60).padStart(2, '0')
  return hours > 0 ? `${hours}:${String(minutes).padStart(2, '0')}:${rest}` : `${minutes}:${rest}`
}

/**
 * «идёт 0:12» — сколько ждём с момента `since` (ISO), раз в секунду. Время читается в таймере, не в отрисовке: отрисовка только
 * форматирует последнее прочитанное. `since === null` — счётчика нет и таймер не крутится.
 */
export function useElapsed(since: string | null): string | null {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (since === null) return undefined
    const tick = () => setNow(Date.now())
    const timer = setInterval(tick, 1000)
    const first = setTimeout(tick, 0)
    return () => {
      clearInterval(timer)
      clearTimeout(first)
    }
  }, [since])
  if (since === null) return null
  const start = Date.parse(since)
  if (Number.isNaN(start)) return null
  return `идёт ${elapsedText((now - start) / 1000)}`
}
